export interface Release {
  /** Стабильный идентификатор — по нему запоминается, что запись уже прочитана. */
  id: string;
  /** YYYY-MM-DD. */
  date: string;
  title: string;
  description: string;
  details: string[];
}

/**
 * «Что нового» — список изменений админки. Живёт в коде, а не в базе: запись
 * появляется вместе с самой функциональностью, в том же коммите, и никакого
 * отдельного администрирования новостей не требует.
 *
 * Новые записи добавляются В НАЧАЛО списка.
 */
export const RELEASES: Release[] = [
  {
    id: 'topbar-search-notifications',
    date: '2026-08-12',
    title: 'Поиск и уведомления в шапке',
    description:
      'Строка поиска ищет по данным разделов, доступных вам, а колокольчик показывает клиентов, требующих внимания.',
    details: [
      'Поиск по клиентам (название, кабинет MT1, ОГРН, почта контакта), тестам, администраторам и ролям',
      'Результат сразу ведёт в карточку клиента или нужный раздел',
      'Уведомления — истёкшие и истекающие кабинеты, кабинеты без подключённых тестов',
    ],
  },
  {
    id: 'dashboard-real-data',
    date: '2026-08-12',
    title: 'Дашборд на реальных данных',
    description:
      'Показатели портфеля считаются по вашим клиентам: сроки кабинетов, оборот у.е., подключённые тесты и обращения в поддержку.',
    details: [
      'Шесть показателей портфеля с динамикой к прошлому месяцу',
      'График портфеля по месяцам и оборот у.е. (выдано / списано)',
      'Блок «Требуют внимания» с переходом сразу к нужному действию',
      'Лента последних событий в кабинетах клиентов',
    ],
  },
  {
    id: 'admins-section',
    date: '2026-08-11',
    title: 'Раздел «Администраторы»',
    description:
      'Учётные записи администраторов — список с поиском и фильтрами, карточка и создание по шагам.',
    details: [
      'Создание по шагам: профиль, единый вход, роли и права',
      'Роли выбираются списком с чипами, права — как в разделе «Роли»',
      'Привязки на сервере авторизования создаются для обеих админок',
    ],
  },
  {
    id: 'roles-permissions',
    date: '2026-08-10',
    title: 'Роли и права',
    description:
      'Раздел «Роли» с полным набором разрешений; права действительно учитываются в интерфейсе.',
    details: [
      'Недоступные разделы скрыты, недоступные действия — в режиме просмотра',
      'Разрешения сгруппированы по разделам с иконками и счётчиком',
    ],
  },
];
